"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var index_1 = require("./index");
var react_select_1 = require("react-select");
var async_1 = __importDefault(require("react-select/async"));
var styles_1 = require("./styles");
var InputLabel_1 = require("../Input/InputLabel");
var Option_1 = require("./Option");
var index_2 = require("./index");
var MultiValueList_1 = require("./MultiValueList");
var AsyncSelect = function (props) {
    var onChange = props.onChange, value = props.value, className = props.className, label = props.label, required = props.required, alwaysShowCounter = props.alwaysShowCounter, styles = props.styles, rest = __rest(props, ["onChange", "value", "className", "label", "required", "alwaysShowCounter", "styles"]);
    var ValueContainer = (0, react_1.useMemo)(function () { return function (props) {
        return (0, jsx_runtime_1.jsx)(MultiValueList_1.MultiValueList, __assign({}, props, { alwaysShowCounter: alwaysShowCounter }), void 0);
    }; }, [alwaysShowCounter]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className }, { children: [label && (0, jsx_runtime_1.jsx)(InputLabel_1.InputLabel, __assign({ required: required }, { children: label }), void 0), (0, jsx_runtime_1.jsx)(async_1.default, __assign({ value: value, cacheOptions: true, defaultOptions: true, components: props.isMulti
                    ? { IndicatorSeparator: index_1.IndicatorSeparator, Option: Option_1.Option, ValueContainer: ValueContainer, DropdownIndicator: index_2.DropdownIndicator }
                    : { IndicatorSeparator: index_1.IndicatorSeparator, DropdownIndicator: index_2.DropdownIndicator }, closeMenuOnSelect: !props.isMulti, controlShouldRenderValue: !props.isMulti, hideSelectedOptions: !props.isMulti, theme: function (theme) { return (__assign(__assign(__assign({}, theme), { colors: __assign({}, theme.colors) }), styles_1.selectThemeStyles)); }, onChange: function (item) {
                    onChange && onChange(item);
                }, isClearable: false, styles: (0, react_select_1.mergeStyles)(styles_1.customStyles, styles) }, rest), void 0)] }), void 0));
};
exports.default = AsyncSelect;
//# sourceMappingURL=AsyncSelect.js.map